const setNewEncodingPayload = (
  img,
  number_video,
  online,
  type,
  newsEntity,
  deletedFiles,
  fireDepartment,
  images,
  iarMember,
  tempUpdatedFiles,
  bodyText
) => {
  let deletedSeconds = 0
  const deletedFilesMap = new Map()
  deletedFiles.forEach((x) => deletedFilesMap.set(x, x))
  newsEntity.videos.forEach((vid) => {
    if (deletedFilesMap.get(vid.fileName)) {
      deletedSeconds += vid.secondsDuration
    }
  })
  const data = {
    title: newsEntity.title,
    richText: bodyText,
    videosNumber: number_video,
    images: img,
    onlineVideos: online,
    type: type,
    contentId: newsEntity._id ? newsEntity._id : '',
    positionFiles: newsEntity && newsEntity.positionFiles ? parseInt(newsEntity.positionFiles) : 0,
    identifier: fireDepartment.identifier,
    fireDepartmentId: fireDepartment.fireDepartmentId,
    socketChannels: [
      `${fireDepartment.fireDepartmentId.toString()}_inner_news_list`,
      `${fireDepartment.fireDepartmentId.toString()}_cms_news`
    ],
    deletedFiles,
    updatedFiles: tempUpdatedFiles,
    deletedSeconds,
    memberId: iarMember.memberId,
    sendPushNotifications: newsEntity.sendPushNotification
  }
  if (newsEntity._id) {
    data.socketChannels.push(
      `${fireDepartment.fireDepartmentId.toString()}_${newsEntity._id}_news_dialog`
    )
  }

  return data
}
const getOnlineVideosPayload = (onlineVideos, fireDepartment) => {
  return onlineVideos?.map((v) => ({
    fireDepartmentIdentifier: fireDepartment.identifier,
    originalName: v.originalName,
    type: 'online',
    fileName: `${v.url}_${Date.now().toString()}`,
    provider: v.provider,
    caption: v.caption,
    fileSize: '',
    url: v.url
  }))
}

const getImagesPayload = (entity, images) => {
  const imagesPayload = images?.filter(
    (i) =>
      !entity.images.some((x) => {
        return x.fileName === i.fileName
      })
  )

  return (
    imagesPayload?.map((image) => ({
      originalName: image.originalName,
      caption: image.caption,
      type: image.type,
      fileSize: image.fileSize,
      binary: image.file
    })) ?? []
  )
}

const getVideosPayload = (entity, videos) => {
  return (
    videos
      ?.filter(
        (x) =>
          !entity?.videos?.some((v) => {
            return x.fileName === v.fileName
          })
      )
      .map((v) => ({
        originalName: v.FileName,
        type: 'video',
        fileSize: v.fileSize,
        caption: v.caption,
        secondsDuration: v.secondsDuration,
        binary: v.binary
      })) ?? []
  )
}

export { getImagesPayload, getOnlineVideosPayload, getVideosPayload, setNewEncodingPayload }
